import styled, { css } from 'styled-components'
import { StyledIconButtonProps } from './IconButton.types'

const sizeStyles = {
  small: css`
    width: 24px;
    height: 24px;
    border-radius: ${({ theme }) => theme.borderRadius.small};
  `,
  medium: css`
    width: 32px;
    height: 32px;
    border-radius: ${({ theme }) => theme.borderRadius.medium};
  `,
  large: css`
    width: 40px;
    height: 40px;
    border-radius: ${({ theme }) => theme.borderRadius.medium};
  `,
}

const variantStyles = {
  default: css`
    background: none;
    border: none;
    color: ${({ theme }) => theme.colors.text.secondary};

    &:hover:not(:disabled) {
      background: ${({ theme }) => theme.colors.background.tertiary};
      color: ${({ theme }) => theme.colors.text.primary};
    }
  `,
  solid: css`
    background: ${({ theme }) => theme.colors.background.primary};
    border: 1px solid ${({ theme }) => theme.colors.border.default};
    color: ${({ theme }) => theme.colors.text.secondary};

    &:hover:not(:disabled) {
      background: ${({ theme }) => theme.colors.background.tertiary};
      border-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.text.primary};
    }
  `,
  ghost: css`
    background: none;
    border: none;
    color: ${({ theme }) => theme.colors.text.secondary};

    &:hover:not(:disabled) {
      background: ${({ theme }) => theme.colors.background.tertiary};
      color: ${({ theme }) => theme.colors.text.primary};
    }
  `,
  secondary: css`
    background: ${({ theme }) => theme.colors.background.secondary};
    border: none;
    color: ${({ theme }) => theme.colors.text.secondary};

    &:hover:not(:disabled) {
      background: ${({ theme }) => theme.colors.background.tertiary};
      color: ${({ theme }) => theme.colors.text.primary};
    }
  `,
  danger: css`
    background: none;
    border: none;
    color: ${({ theme }) => theme.colors.danger};

    &:hover:not(:disabled) {
      background: rgba(255, 59, 48, 0.1);
      color: ${({ theme }) => theme.colors.danger};
    }
  `,
}

export const StyledIconButton = styled.button<StyledIconButtonProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.fast};
  position: relative;
  padding: 0;

  ${(props) => sizeStyles[props.$size]}
  ${(props) =>
    variantStyles[props.$variant as keyof typeof variantStyles] ??
    variantStyles.default}

  &:active:not(:disabled) {
    transform: translateY(1px);
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.border.focus};
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Touch-friendly sizes on mobile and touch devices */
  @media (max-width: 1023px) {
    min-width: ${({ theme }) => theme.touchTargets.minimum};
    min-height: ${({ theme }) => theme.touchTargets.minimum};
  }

  @media (hover: none) and (pointer: coarse) {
    min-width: ${({ theme }) => theme.touchTargets.minimum};
    min-height: ${({ theme }) => theme.touchTargets.minimum};
  }

  /* Disable hover effects on touch devices */
  @media (hover: none) {
    &:hover:not(:disabled) {
      background: inherit;
      color: inherit;
      transform: none;
    }

    &:active:not(:disabled) {
      background: ${({ theme }) => theme.colors.background.tertiary};
    }
  }
`
